import type React from 'react';
import Logo from '../../layout/Navbar/Logo';
import DashboardSideMenu from './DashboardSideMenu';
import DashboardSideMenuUserLogo from './DashboardSideMenuUserLogo';

export type DashboardSideMenuPanelProps = {
  onDesktop: boolean;
};

const DashboardSideMenuPanel: React.FC<DashboardSideMenuPanelProps> = ({
  onDesktop,
}) => (
  <div
    className={`flex min-h-full grow flex-col ${
      onDesktop ? 'border-r' : 'bg-slate-500'
    }`}
  >
    <div className="flex min-h-full grow flex-col items-start justify-start gap-0">
      <div className="hidden h-[80px] max-h-[80px] min-w-full flex-col p-1 lg:flex">
        <Logo size={22} showText />
      </div>
      <div className="flex min-w-full flex-col lg:hidden">
        <DashboardSideMenuUserLogo />
      </div>
      <div className="flex max-h-[calc(100dvh-72px)] min-w-full grow flex-col overflow-y-auto">
        <DashboardSideMenu />
      </div>
    </div>
  </div>
);

export default DashboardSideMenuPanel;
